import SaveItem from './save-item';

export default class ConfiguredCar extends SaveItem {
    constructor(parent, source, data) {
        super(parent);
        this.router = parent.router;
        this.myAccount = parent.myAccount;
        this.script = parent?.parent?.el?.querySelector('#configured-car');

        if (this.script && this.script.innerHTML) {
            var templateStr = this.script.innerHTML.replace(/\\/g, '');
            this.template = _.template(templateStr, { interpolate: /(?:<%=|{{)([\s\S]+?)(?:%>|}})/g });
        } else {
            this.template = null;
        }

        this.data = this.create(source, data);
    }

    create(source, data) {
        if (source === 'url') {
            return this.fromURL();
        } else if (source === 'myAccount') {
            return this.fromMyAccount(data);
        } else {
            return {
                ...data,
                wishlistId: data.wishlistId ?? '',
                shareCode: data.shareCode ?? '',
            };
        }
    }

    fromURL() {
        const params = Object.fromEntries(this.router.params);
        return {
            type: 'HondaCarConfiguratorOffer',
            id: this.uuid(),
            synced: false,
            model: params.model,
            vehicleName: params['vehicle-name'],
            carBasePrice: +params['car-base-price'],
            carTotalPrice: +params['car-total-price'],
            trim: params.trim,
            carTrimCode: params['car-trim-code'],
            carShortUrl: params['car-short-url'],
            carLongUrl: params['car-long-url'],
            gradeEngine: params['grade-engine'],
            gradeEngineCode: params['grade-engine-code'],
            carColour: params['car-colour'],
            carColourCode: params['car-colour-code'],
            selectedAccessoriesWithoutStandardAlloys: params['selected-accessories-without-standard-alloys'],
            specId: params['spec-id'],
            financeOfferDesc: params['finance-offer-desc'],
            financeParams: this.fromFinanceString(params['finance-offer-desc']),
            servicingSelected: this.boolean(params['servicing-selected']),
            shareWithDealer: false,
            dateCreated: new Date().toISOString(),
            mtoce: params['mtoce'],
            wishlistId: params['wishlistId'],
            shareCode: params['shareCode'],
        };
    }

    fromMyAccount(offer) {
        return {
            type: 'HondaCarConfiguratorOffer',
            id: offer.id,
            synced: true,
            model: offer.vehicleModel,
            vehicleName: offer.vehicleName,
            carBasePrice: +offer.baseAmount,
            carTotalPrice: +offer.totalAmount,
            trim: offer.vehicleInteriorColour,
            carTrimCode: offer.vehicleInteriorColourCode,
            carShortUrl: offer.externalURL,
            carLongUrl: offer.externalURL,
            gradeEngine: offer.vehicleEngine,
            gradeEngineCode: offer.vehicleEngineCode,
            carColour: offer.vehicleColour,
            carColourCode: offer.vehicleColourCode,
            selectedAccessoriesWithoutStandardAlloys: (offer.optionalAccessories || []).join(', '),
            specId: offer.specId,
            financeOfferDesc: this.toFinanceString(offer),
            financeParams: this.toFinance(offer),
            servicingSelected: this.boolean(offer.serviceSelected),
            shareWithDealer: offer.shareWithDealer,
            dateCreated: offer.dateCreated ? new Date(offer.dateCreated).toISOString() : new Date().toISOString(),
            wishlistId: null,
            shareCode: null,
        };
    }

    fromFinanceString(str) {
        if (!str) { return null; }
        const decoded = decodeURI(str);
        const obj = new URLSearchParams(decoded);
        const params = Object.fromEntries(obj);
        return {
            financeOfferTerm: +params['finance-offer-term'],
            financeOfferMileage: +params['finance-offer-mileage'],
            financeOfferDeposit: +params['finance-offer-deposit'],
            financeOfferType: params['finance-offer-type'],
            financeFinalPayment: +params['finance-final-payment'],
            financeHondaDeposit: +params['finance-honda-deposit'],
            financeInterestRate: +params['finance-interest-rate'],
            financeInterestRateRepresentative: +params['finance-interest-rate-representative'],
            financeOfferExpiry: params['finance-offer-expiry'],
            financeMonthlyInstallment: +params['finance-monthly-installment'],
        };
    }

    toFinanceString(offer) {
        const obj = new URLSearchParams(this.toFinance(offer));
        return obj.toString();
    }

    toFinance(offer) {
        return {
            financeOfferTerm: +offer.term,
            financeOfferMileage: +offer.annualMiles,
            financeOfferDeposit: +offer.deposit,
            financeOfferType: offer.offerType,
            financeFinalPayment: +offer.finalPayment,
            financeHondaDeposit: +offer.hondaDeposit,
            financeInterestRate: +offer.interestRate,
            financeInterestRateRepresentative: +offer.apr,
            financeOfferExpiry: offer.expiration,
            financeMonthlyInstallment: +offer.monthlyPayment,
        }
    }

    async toMyAccount() {
        try {
            const result = await this.myAccount.mutate('saveCar', {
                id: this.data.id,
                model: this.data.model,
                vehicleName: this.data.vehicleName,
                carBasePrice: this.data.carBasePrice,
                carTotalPrice: this.data.carTotalPrice,
                trim: this.data.trim,
                carTrimCode: this.data.carTrimCode,
                carShortUrl: this.data.carShortUrl,
                carLongUrl: this.data.carLongUrl,
                gradeEngine: this.data.gradeEngine,
                gradeEngineCode: this.data.gradeEngineCode,
                carColour: this.data.carColour,
                carColourCode: this.data.carColourCode,
                selectedAccessoriesWithoutStandardAlloys: this.data.selectedAccessoriesWithoutStandardAlloys,
                financeOfferDesc: this.data.financeOfferDesc,
                servicingSelected:this.boolean(this.data.servicingSelected),
            });
            this.data.id = result.data.saveCarConfiguratorOffer.id;   
            return { success: true, result: result };
        } catch (err) {
            console.error(`Unable to add: ${this.data.id}`, err);
            return { success: false, error: err };
        }
    }

    async removeMyAccount() {
        try {
            const result = await this.myAccount.mutate('deleteCar', {
                id: this.data.id,
                previouslySharedWithDealer: this.data.shareWithDealer || false,
            });
            return { success: true, result: result }
        } catch(err) {
            console.error(`Unable to remove: ${this.data.id}`, err);
            return { success: false, error: err }
        }
    }
}
